import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { map, mergeMap, Observable, take } from 'rxjs';
import { ADMIN_EMAILS, ADMIN_PHONES } from 'src/definitions/custom';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<any>,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {

    return this.store.select((state) => state.AuthDataStore.user).pipe(
      take(1),
      map((user: any) => {
        // Check if userEmail is not null/undefined AND is included in the allowed list
        const hasAdminEmail = user?.email && ADMIN_EMAILS.includes(user.email);
        const hasAdminPhone = user?.phoneNumber && ADMIN_PHONES.includes(user.phoneNumber);
        const isAllowed = hasAdminEmail || hasAdminPhone;


        if (!isAllowed) {
          console.warn('Access denied - Admins only');
          this.router.navigate(['/users/profile']);
        }
        return isAllowed;
      }),
    );
  }
}


